import { render } from "./CorporateDashboard.vue?vue&type=template&id=3aa34b45&scoped=true"
import script from "./CorporateDashboard.vue?vue&type=script&lang=js"
export * from "./CorporateDashboard.vue?vue&type=script&lang=js"

import "./CorporateDashboard.vue?vue&type=style&index=0&id=3aa34b45&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa34b45"]])

export default __exports__